import React from 'react';

interface TimelineMilestone {
  title: string;
  Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  description: string;
  isCompleted?: boolean;
}

interface TimelineProps {
  milestones: TimelineMilestone[];
  // Additional customization parameters
  lineColor?: string;
  dotSize?: number;
  iconSize?: number;
  titleClassName?: string;
  descriptionClassName?: string;
  containerClassName?: string;
}

const Timeline: React.FC<TimelineProps> = ({ 
  milestones,
  lineColor = "bg-success-green/30",
  dotSize = 36,
  iconSize = 20,
  titleClassName = "text-white font-primary font-medium text-base",
  descriptionClassName = "text-white/50 font-primary font-regular text-xs",
  containerClassName = "w-full py-4"
}) => {
  return (
    <div className={containerClassName}>
      <div className="flex items-center justify-between relative">
        {/* Timeline line */}
        <div className={`absolute left-0 top-[16px] w-full h-1 rounded-full ${lineColor}`} />
        
        {milestones.map((milestone, index) => (
          <div key={index} className="relative flex flex-col items-center">
            {/* Milestone dot */}
            <div 
              className={`w-[${dotSize}px] h-[${dotSize}px] rounded-full flex items-center justify-center ${
                milestone.isCompleted ? 'bg-success-green' : 'bg-white'
              } z-10`} 
            >
              <milestone.Icon className={`w-[${iconSize}px] h-[${iconSize}px] ${milestone.isCompleted ? 'fill-white' : 'fill-brand-blue'}`} />
            </div>
            
            {/* Milestone content */}
            <div className="mt-2 text-center px-5">
              <h3 className={titleClassName}>
                {milestone.title}
              </h3>
              <p className={descriptionClassName}>
                {milestone.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Timeline; 